module.exports = __webpack_public_path__ + "teqbahn-assets/media/4.960ab478.jpg";